import './TaskTemplate.style.less'

import { get, has } from 'lodash'

import { FunctionComponent } from 'react'
import { TASK_TEMPLATE } from './TaskTemplate.config'
import { ITemplateProp } from '../../../../../../TaskTemplate.interface'

interface Prop {
  data: any
  sectionId?: string
}

function TaskTemplate(props: Prop) {
  const { data } = props
  const { type } = data

  if (!has(TASK_TEMPLATE, type)) return <></>

  const Template: FunctionComponent<ITemplateProp> = get(
    TASK_TEMPLATE,
    type,
    <>{type}</>
  ) as FunctionComponent<ITemplateProp>

  return (
    <>
      <Template data={data} sectionId={data.section_id} /> <hr />
    </>
  )
}

export default TaskTemplate
